module.exports = __webpack_public_path__ + "img/fuwu6.d7060179.png";